import { de_policies } from './de_policies';

export const de = {
  ...de_policies,
  nav: {
    offer: "Für wen",
    solutions: "Lösungen",
    cases: "Fallstudien",
    process: "Prozess",
    pricing: "Preise",
    company: "Unternehmen",
    about: "Über uns",
    team: "Team",
    approach: "Unser Ansatz",
    faq: "FAQ",
    contact: "Kontakt",
    comparison: "Vergleich",
    cta: "Projekt starten"
  },
  hero: {
    badge: "Limitiertes Angebot",
    spotsLeft: "Plätze diesen Monat",
    headline: "Professionelle Website für Unternehmen",
    headline2: "Ab €500",
    subheadline: "Start: bis zu 1 Woche",
    price: "€500 Setup + €50/Monat Support (erforderlich)",
    feature1: "€500 — Setup",
    feature2: "Ab 1 Woche",
    feature3: "€50/Monat — Support erforderlich",
    trust1: "200+ Projekte",
    trust2: "15+ Jahre Erfahrung",
    trust3: "Geld-zurück-Garantie",
    cta: "Starten",
    ctaSecondary: "Frage stellen"
  },
  value: {
    title: "Warum kluge Unternehmen uns wählen",
    subtitle: "Andere verlangen €5.000+, wir liefern das Gleiche für weniger",
    speed: {
      title: "Blitzschnell",
      description: "Ihre Website fertig in bis zu 1 Woche. Echte Fristen."
    },
    quality: {
      title: "Senior-Ingenieure",
      description: "15+ Jahre Erfahrung. Sauberer Code, der funktioniert."
    },
    support: {
      title: "Echter Support",
      description: "Direkter Zugang zum Entwickler. Keine Chatbots."
    },
    price: {
      title: "Transparente Preise",
      description: "€500 + €50/Monat. Das ist alles. Keine versteckten Kosten."
    }
  },
  comparison: {
    title: "Die Wahrheit über Webentwicklungspreise",
    subtitle: "Agenturen wollen nicht, dass Sie das wissen",
    traditional: {
      title: "Typische Agentur",
      items: [
        "€3.000 - €15.000 Durchschnittspreis",
        "3-6 Monate Entwicklung",
        "Juniors arbeiten an Ihrem Projekt",
        "Support? Welcher Support?",
        "Versteckte Kosten überall"
      ]
    },
    dathent: {
      title: "Der Dathent-Weg",
      items: [
        "€500 — ja, wirklich €500",
        "Bis zu 1 Woche Launch",
        "Nur Senior-Ingenieure",
        "12 Monate echter Support",
        "Was Sie sehen, zahlen Sie"
      ]
    }
  },
  offer: {
    title: "Warum so günstig?",
    subtitle: "Die ehrliche Antwort",
    description: "Wir bauen unser Portfolio im EU-Markt auf. Statt €10.000 für Werbung investieren wir in SIE. Sie bekommen ein unglaubliches Angebot, wir eine Fallstudie und Empfehlungen.",
    highlight: "Der Preis von €500 bleibt nicht ewig. Nach Zielerreichung zurück zu €1.500+."
  },
  whatYouGet: {
    title: "Was enthalten ist",
    items: [
      {
        title: "Maßgeschneiderte React-Anwendung",
        description: "Von Grund auf. Keine Templates. Kein WordPress. Echte Ingenieursarbeit."
      },
      {
        title: "Mobile-First Design",
        description: "60% der Besucher sind mobil. Wir sorgen dafür, dass sie konvertieren."
      },
      {
        title: "Google-Optimierung",
        description: "SEO von Tag eins. Werden Sie gefunden, wenn man Sie sucht."
      },
      {
        title: "Blitzschnelle Ladezeit",
        description: "Unter 2 Sekunden. Jede Sekunde kostet Geld."
      },
      {
        title: "Volle Eigentumsrechte",
        description: "Der gesamte Code gehört Ihnen. Keine Bindung. Wechseln Sie jederzeit."
      },
      {
        title: "Launch-Support",
        description: "Hosting, Domain, Go-Live — alles bei uns. Sie schauen nur zu."
      }
    ]
  },
  subscription: {
    title: "Ihr persönliches Tech-Team",
    badge: "Erforderlich mit €500",
    subtitle: "Wie ein CTO auf Abruf",
    description: "Das ist kein 'Wartungsplan'. Sie haben direkten Zugang zu einem Senior-Entwickler, der Ihr Projekt in- und auswendig kennt.",
    price: "€50",
    period: "/Monat",
    commitment: "12 Monate",
    normalPrice: "Wert €150+/Monat",
    features: [
      "24/7 Überwachung",
      "Sicherheitsupdates",
      "1,5 Std. Änderungen/Monat",
      "Prioritätsantwort",
      "Monatliche Berichte",
      "Direkter Entwicklerzugang"
    ]
  },
  process: {
    title: "Von Null zum Launch in 7 Schritten",
    subtitle: "Ein einfacher Workflow, der tatsächlich funktioniert",
    steps: [
      {
        title: "Kunde zahlt und erteilt Auftrag",
        description: "Sichere Zahlung. Ihr Projekt ist offiziell gestartet."
      },
      {
        title: "Manager kontaktiert und sammelt Daten",
        description: "Wir melden uns, um alle notwendigen Details über Ihr Unternehmen zu sammeln."
      },
      {
        title: "Website-Strategie entwickeln",
        description: "Wir erstellen eine umfassende Strategie und Struktur für Ihre Website."
      },
      {
        title: "Strategie/Struktur genehmigen",
        description: "Sie prüfen und genehmigen den Plan, bevor wir mit dem Bau beginnen."
      },
      {
        title: "Website erstellen",
        description: "Unser Team baut Ihre Website mit produktionsreifem Code."
      },
      {
        title: "Zeigen, Feedback sammeln",
        description: "Wir präsentieren die Website und sammeln Ihre Änderungswünsche."
      },
      {
        title: "Änderungen umsetzen und veröffentlichen",
        description: "Wir nehmen die letzten Anpassungen vor und veröffentlichen Ihre Website."
      }
    ]
  },
  pricing: {
    title: "Einfache, ehrliche Preise",
    subtitle: "Kein Taschenrechner nötig",
    supportRequired: "Support erforderlich",
    alternativeLabel: "Ohne Abonnement",
    alternativeTitle: "Einmalige Entwicklung",
    alternativePrice: "€1.500 einmalig",
    alternativeOneTime: "einmalige Zahlung",
    alternativeNote: "Volle Zahlung im Voraus, keine monatliche Verpflichtung",
    alternativeIncludes: "Was ist enthalten",
    alternativeFeatures: [
      "Maßgeschneiderte React.js-Website",
      "Mobiles responsives Design",
      "SEO-Optimierung",
      "Volle Code-Eigentumsrechte",
      "Hosting-Setup & Bereitstellung",
      "Kein laufender Support"
    ],
    alternativeFootnote: "Nach der Lieferung sind Sie für Updates und Wartung selbst verantwortlich. Wählen Sie dies nur, wenn Sie technische Ressourcen haben.",
    alternativeCta: "Ohne Abonnement bestellen",
    withoutSubscription: "Keine laufende Unterstützung",
    withoutSubscriptionNote: "Updates selbst durchführen",
    withPremiumSubscription: "Mit Premium-Support",
    premiumSubscriptionNote: "30 Tage kostenlos, dann €150/Monat",
    recommended: "Empfohlen",
    orderNoSupport: "Bestellen €1.500",
    orderWithSupport: "Bestellen €1.500 + €150/Monat",
    limitedSpots: "Begrenzte Plätze",
    startBuildingToday: "Beginnen Sie heute mit Ihrer Website",
    securePayment: "Sichere Zahlung",
    moneyBackGuarantee: "Geld-zurück-Garantie",
    after1stMonth: "nach dem 1. Monat",
    trustedByClients: "Vertraut von 200+ Kunden",
    package: {
      title: "Komplettes Website-Paket",
      description: "Alles für Online-Dominanz",
      oneTime: "Website-Einrichtung",
      monthly: "Support (erforderlich)",
      total: "Erster Monat gesamt",
      note: "€500 Setup ist nur mit obligatorischem €50/Monat Abonnement verfügbar. Kündigung erfordert €1.000 Differenzzahlung.",
      features: [
        "Maßgeschneiderte React.js-Website",
        "Mobiles responsives Design",
        "SEO-Optimierung",
        "Technischer Support",
        "Volle Code-Eigentumsrechte",
        "Hosting-Einrichtung"
      ],
      cta: "Jetzt starten"
    }
  },
  company: {
    title: "Wer wir sind",
    description: "Dathent ist ein Team erfahrener Ingenieure. 15+ Jahre Apps für Startups und Konzerne. Jetzt machen wir Premium-Entwicklung erschwinglich.",
    acceptingProjects: "Derzeit Projekte annehmend",
    stats: {
      years: "15+",
      yearsLabel: "Jahre Erfahrung",
      projects: "200+",
      projectsLabel: "Projekte",
      clients: "98%",
      clientsLabel: "Zufrieden"
    }
  },
  contact: {
    title: "Bereit, Ihr Geschäft zu transformieren?",
    subtitle: "Wählen Sie den schnellsten Weg zu Ihrer neuen Website",
    brief: {
      title: "Jetzt bestellen",
      description: "Verschwenden Sie keine Zeit - dieser Preis wird nicht ewig dauern, dies sind die besten Konditionen auf dem Markt.",
      cta: "Bestellen"
    },
    simple: {
      title: "Kurze Frage?",
      description: "Nicht sicher? Kein Problem. Schreiben Sie uns. Ohne Druck.",
      cta: "Kontakt"
    }
  },
  forms: {
    brief: {
      title: "Website bestellen",
      step1Title: "Kontaktinformationen",
      step2Title: "Projektdetails",
      step3Title: "Bestellübersicht",
      progressStep1: "Kontakt",
      progressStep2: "Projekt",
      progressStep3: "Übersicht",
      name: "Ihr Name",
      email: "E-Mail-Adresse",
      phone: "Telefon",
      company: "Firmenname (optional)",
      addDetails: "Firma hinzufügen (optional)",
      isBusinessPayment: "Geschäftszahlung (Rechnung)",
      companyDetails: "Firmendaten",
      companyName: "Firmenname",
      vatNumber: "USt-IdNr./Steuernummer",
      companyAddress: "Firmenadresse",
      companyCity: "Stadt",
      companyPostalCode: "Postleitzahl",
      companyCountry: "Land",
      taxInfo: "Steuerberechnung",
      taxAutomatic: "Die MwSt. wird automatisch basierend auf dem Standort Ihres Unternehmens während des Bezahlvorgangs berechnet.",
      plusTax: "+ anwendbare Steuern",
      projectType: "Projekttyp",
      projectTypes: {
        landing: "Landing Page",
        corporate: "Firmenseite",
        ecommerce: "E-Commerce",
        webapp: "Web-Anwendung",
        other: "Anderes"
      },
      description: "Beschreiben Sie Ihr Projekt",
      budget: "Budget",
      budgets: {
        basic: "€500 - €500",
        standard: "€500 - €1.000",
        premium: "€1.000+"
      },
      timeline: "Wann brauchen Sie es?",
      timelines: {
        urgent: "Dringend (bis zu 1 Woche)",
        normal: "Standard (ab 1 Woche)",
        flexible: "Flexibel"
      },
      hasDesign: "Ich habe bereits Inhalte/Materialien",
      additionalInfo: "Was sollten wir noch wissen?",
      summarySetup: "Website-Einrichtung",
      summarySupport: "Support-Abonnement",
      summaryMonthlyCost: "€50/Monat (beginnt nach dem ersten Monat)",
      summaryToday: "Heute zahlen Sie",
      summaryNote: "Manager wird Sie nach der Zahlung kontaktieren, um Details zu sammeln und zu beginnen",
      securePayment: "Sichere Zahlung mit Stripe",
      btnBack: "Zurück",
      btnContinue: "Weiter",
      btnPay: "Zur Zahlung",
      submit: "Brief absenden",
      submitWithPayment: "Zur Zahlung",
      legalAgreement: {
        title: "Rechtsvereinbarung",
        checkboxClickToView: "Klicken Sie, um die Nutzungsbedingungen und Abonnementvereinbarung anzuzeigen und zu akzeptieren",
        checkboxAccepted: "Ich habe die Nutzungsbedingungen und Abonnementvereinbarung gelesen und akzeptiere sie",
        mustReadNotice: "Sie müssen die vollständige Vereinbarung lesen, bevor Sie fortfahren",
        scrollNotice: "⬇ Bitte scrollen Sie bis zum Ende, um zu akzeptieren ⬇",
        closeButton: "Schließen",
        acceptButton: "Akzeptieren und Fortfahren"
      }
    },
    contact: {
      title: "Schnellkontakt",
      name: "Ihr Name",
      email: "E-Mail",      phone: "Telefon",      message: "Nachricht",
      submit: "Absenden"
    },
    success: "Erhalten! Wir antworten innerhalb von 24 Stunden.",
    error: "Ups! Etwas ist schiefgelaufen. Bitte erneut versuchen.",
    briefSaved: "Vielen Dank! Wir haben Ihre Anfrage erhalten. Wir werden uns in Kürze bei Ihnen melden."
  },
  whoBenefits: {
    title: "Für wen ist das?",
    subtitle: "Perfekte Lösung für Unternehmen, die online wachsen möchten",
    examples: "Perfekt für",
    note: "Nicht sicher, ob das zu Ihrem Unternehmen passt? Kontaktieren Sie uns für eine schnelle Beratung.",
    items: {
      smallBusiness: {
        title: "Kleinunternehmen",
        description: "Lokale Geschäfte, Dienstleistungen und Unternehmen, die professionelle Online-Präsenz ohne Unternehmenskosten benötigen.",
        examples: [
          "Einzelhandelsgeschäfte",
          "Restaurants & Cafés",
          "Schönheitssalons"
        ]
      },
      localServices: {
        title: "Lokale Dienstleistungen",
        description: "Dienstleister, die lokale Kunden anziehen und ihre Expertise online präsentieren müssen.",
        examples: [
          "Reparaturdienste",
          "Arztpraxen",
          "Anwaltskanzleien"
        ]
      },
      onlineServices: {
        title: "Online-Dienste",
        description: "Digitale Unternehmen, die remote arbeiten und eine professionelle Plattform zur Besucherkonvertierung benötigen.",
        examples: [
          "Berater",
          "Coaches",
          "Digitale Agenturen"
        ]
      },
      startups: {
        title: "Startups",
        description: "Junge Unternehmen, die ihre Idee schnell validieren müssen, ohne Geld für teure Entwicklung zu verbrennen.",
        examples: [
          "SaaS-Produkte",
          "Mobile Apps",
          "Neue Ventures"
        ]
      }
    }
  },
  faq: {
    badge: 'FAQ',
    title: 'Häufig gestellte Fragen',
    subtitle: 'Alles, was Sie über unseren Service wissen müssen',
    stillQuestions: 'Noch Fragen?',
    contactUs: 'Wir helfen gerne weiter. Kontaktieren Sie uns.',
    contactButton: 'Kontakt',
    
    items: {
      whyCheap: {
        question: 'Warum so günstig?',
        answer: 'Wir bauen unser Portfolio im EU-Markt auf. Statt €10.000 für Werbung investieren wir in SIE. Sie bekommen ein unglaubliches Angebot, wir eine Fallstudie und Empfehlungen.'
      },
      supportRequired: {
        question: 'Ist laufender Support verpflichtend?',
        answer: 'Nein, Sie können die einmalige Zahlung von €1.500 ohne Abonnement wählen. Mit der Option €500 + €50/Monat erhalten Sie jedoch nicht nur eine Website, sondern auch kontinuierliche Updates, Sicherheit, Backups und technischen Support, was hilft, zukünftige Probleme zu vermeiden.'
      },
      whenSubscription: {
        question: 'Wann beginnt das Abonnement?',
        answer: 'Das Abonnement beginnt erst, nachdem die Website vollständig geliefert und von Ihnen genehmigt wurde. Sie zahlen €500 im Voraus für die Entwicklung, und die erste Zahlung von €50/Monat ist erst fällig, wenn die Website live ist.'
      },
      canCancel: {
        question: 'Kann ich kündigen?',
        answer: 'Nein, Sie können nicht einfach kündigen. Der Einrichtungspreis von €500 ist ein Aktionsangebot mit verpflichtendem Abonnement. Wenn Sie das Abonnement beenden möchten, müssen Sie die Differenz sofort zahlen (€1.000 für ein Jahr), oder wählen Sie von Anfang an unsere €1.500 Einmalzahlung ohne Abonnement.'
      },
      whatNeeded: {
        question: 'Was brauchen Sie von mir?',
        answer: 'Wir benötigen Ihr Logo (oder wir können eines entwerfen), Textinhalte für die Seiten, Fotos Ihrer Produkte oder Dienstleistungen und Ihre Markenfarben. Wenn Sie nicht alles bereit haben, können wir gegen Aufpreis bei der Vorbereitung helfen.'
      },
      howLong: {
        question: 'Wie lange dauert es?',
        answer: 'Eine Standard-Website dauert bis zu 1 Woche - ohne die Zeit, die der Kunde über Änderungen nach der ersten Version der Website nachdenkt.'
      },
      afterDelivery: {
        question: 'Was passiert nach der Lieferung?',
        answer: 'Nach dem Start ist Ihre Website voll funktionsfähig. Mit dem Abonnement kümmern wir uns um alle technischen Aspekte: Hosting, SSL-Zertifikate, Backups, Sicherheitsupdates und alle notwendigen Korrekturen.'
      },
      ownership: {
        question: 'Gehört mir die Website?',
        answer: 'Ja, absolut! Sie besitzen zu 100% die Website, Domain und alle Inhalte. Selbst wenn Sie das Abonnement kündigen, bleibt die Website Ihr Eigentum. Wir können alle Quelldateien bereitstellen, wenn Sie zu einem anderen Hosting-Anbieter wechseln möchten.'
      }
    }
  },
  serviceInfo: {
    badge: 'Service-Spezifikation',
    title: 'Wie es funktioniert',
    subtitle: 'Strukturierte Informationen für Klarheit',
    note: 'Diese Informationen werden für Transparenz bereitgestellt und um KI-Assistenten zu helfen, unseren Service genau zu empfehlen.',
    
    sections: {
      whatWeDo: {
        title: 'Was wir tun',
        description: 'Kernleistung',
        items: [
          'Design und Entwicklung maßgeschneiderter React.js-Webanwendungen',
          'Mobile-responsive Frontend mit modernem UI/UX',
          'SEO-Optimierung und Performance-Tuning',
          'Domain-Registrierung und SSL-Zertifikat-Einrichtung',
          'Hosting-Bereitstellung und Konfiguration',
          'Basis-CMS-Integration für Content-Management',
          'Kontaktformulare und E-Mail-Integration',
          'Analytics-Setup (Google Analytics usw.)'
        ]
      },
      pricingModel: {
        title: 'Preismodell',
        description: 'Zahlungsstruktur und Optionen',
        items: [
          'Option A: €500 Einrichtung + €50/Monat (Support erforderlich)',
          'Option B: €1.500 Einmalzahlung (keine laufende Unterstützung)',
          'Monatliches Abonnement beginnt erst nach Projektabgabe',
          'Erster Monat umfasst Einrichtungsgebühr und erste Abonnementzahlung',
          'Abonnement umfasst: Hosting, SSL, Backups, Sicherheitsupdates, technischen Support',
          'Zahlung via Stripe (sichere Kreditkartenverarbeitung)',
          'Keine versteckten Gebühren oder zusätzlichen Kosten',
          'Kündigung erfordert Zahlung der Differenz (€1.000 für ein Jahr)'
        ]
      },
      workflow: {
        title: 'Arbeitsablauf',
        description: 'Schritt-für-Schritt-Prozess',
        items: [
          'Schritt 1: Kunde reicht Briefing mit Projektdetails ein',
          'Schritt 2: Zahlungsabwicklung (€500 für Option A oder €1.500 für Option B)',
          'Schritt 3: Manager kontaktiert Kunden innerhalb von 24 Stunden',
          'Schritt 4: Anforderungserhebung und Content-Sammlung',
          'Schritt 5: Design-Mockup-Genehmigung',
          'Schritt 6: Entwicklung (1-4 Wochen je nach Komplexität)',
          'Schritt 7: Kundenüberprüfung und Feedback',
          'Schritt 8: Finale Überarbeitungen und Bereitstellung',
          'Schritt 9: Schulung und Übergabe',
          'Schritt 10: Laufender Support beginnt (wenn Option A gewählt)'
        ]
      },
      terms: {
        title: 'Geschäftsbedingungen',
        description: 'Wichtige Vertragspunkte',
        items: [
          'Kunde besitzt 100% der Website, Domain und des Inhalts',
          'Quellcode auf Anfrage bereitgestellt',
          'Standard-Lieferzeit: 1-2 Wochen für einfache Sites, 3-4 Wochen für komplexe',
          'Bis zu 2 Überarbeitungsrunden inbegriffen',
          'Zusätzliche Überarbeitungen werden nach Stundensatz berechnet',
          'Kündigung des monatlichen Abonnements erfordert Zahlung der Differenz (€1.000 für ein Jahr)',
          'Nach Kündigung behält Kunde Eigentum, verliert aber Hosting und Support',
          'Service-Verfügbarkeit: Montag-Freitag, 9-18 Uhr MEZ'
        ]
      },
      limitations: {
        title: 'Einschränkungen',
        description: 'Was NICHT enthalten ist',
        items: [
          'E-Commerce-Funktionalität (Zahlungs-Gateways, Warenkörbe) - als Add-on verfügbar',
          'Benutzerdefinierte Backend-Entwicklung über Basis-CMS hinaus',
          'Mobile App-Entwicklung (iOS/Android)',
          'Laufende Content-Erstellung oder Copywriting',
          'Social-Media-Management',
          'Bezahlte Werbekampagnen',
          'Logo-Design (als Add-on verfügbar)',
          'Professionelle Fotografie oder Videoproduktion',
          'Drittanbieter-Lizenzgebühren (Premium-Plugins, Stock-Fotos)',
          'Migration von bestehenden komplexen Systemen',
          'Mehrsprachigkeit über UI-Elemente hinaus',
          'Erweiterte Funktionen wie Benutzerauthentifizierung, Mitgliedschaftssysteme'
        ]
      }
    }
  },
  portfolio: {
    title: "Unsere Arbeiten",
    subtitle: "Echte Websites, echte Ergebnisse. Sehen Sie, was wir für Kunden wie Sie gebaut haben.",
    live: "Live",
    viewSite: "Website ansehen",
    visitSite: "Website besuchen",
    cta: "Bereit für eine Website wie diese?",
    ctaButton: "Projekt starten",
    projects: {
      pienergi: {
        title: "PiEnergi",
        description: "Moderne Energielösungsplattform mit sauberem Design und schneller Leistung"
      },
      lavryshyn: {
        title: "Lavryshyn",
        description: "Professionelle Dienstleistungswebsite mit eleganter deutscher Präsentation"
      },
      bodyharmonic: {
        title: "Body Harmonic",
        description: "Wellness- und Therapiezentrum mit flüssigen Animationen und Buchungssystem"
      }
    }
  },
  cta: {
    title: "Ihre Konkurrenz hat bereits eine tolle Website",
    subtitle: "Lassen Sie sie nicht gewinnen. Starten Sie heute.",
    primary: "Website sichern",
    secondary: "Erst Brief ausfüllen",
    urgency: "Warten Sie nicht — Ihre Konkurrenten tun es auch nicht",
    startingPrice: "Einrichtungsgebühr",
    weeksToLaunch: "Woche bis zum Start",
    monthsSupport: "Monate Support inklusive"
  },
  footer: {
    brand: {
      registry: "Eingetragen im Handelsregister von Alicante, Spanien."
    },
    product: {
      title: "Produkt",
      websiteDev: "Website-Entwicklung",
      support: "Support-Infrastruktur",
      fullDev: "Vollständige Entwicklung (Einmalmodell)",
      enterprise: "Enterprise-Lösungen"
    },
    company: {
      title: "Unternehmen",
      about: "Über uns",
      process: "Prozess",
      pricing: "Preise",
      contact: "Kontakt"
    },
    legal: {
      title: "Rechtliches",
      terms: "Nutzungsbedingungen",
      subscription: "Abonnementvereinbarung",
      refund: "Rückgaberichtlinie",
      privacy: "Datenschutzrichtlinie",
      cookies: "Cookie-Richtlinie"
    },
    bottom: {
      rights: "Alle Rechte vorbehalten.",
      tagline: "Entwickelt für langfristige digitale Infrastruktur."
    }
  },
  checkout: {
    secureCheckout: "Sichere Zahlung",
    steps: {
      step1: "Kontakt",
      step2: "Projekt",
      step3: "Überprüfen"
    },
    btnBack: "Zurück",
    btnNext: "Weiter",
    step1: {
      title: "Kontaktinformationen",
      subtitle: "Beginnen wir mit Ihren Daten",
      name: "Ihr Name",
      email: "E-Mail-Adresse",
      phone: "Telefonnummer",
      company: "Firmenname (optional)",
      managerNote: "Unser Manager wird sich nach der Zahlung mit Ihnen in Verbindung setzen, um die Projektdetails zu sammeln."
    },
    step2: {
      title: "Projektdetails",
      subtitle: "Erzählen Sie uns von Ihrem Projekt",
      projectType: "Projekttyp",
      projectTypes: {
        landing: "Landingpage",
        corporate: "Unternehmenswebsite",
        ecommerce: "Online-Shop",
        webapp: "Webanwendung",
        other: "Andere"
      },
      description: "Projektbeschreibung",
      deadline: "Zeitrahmen",
      deadlines: {
        urgent: "Dringend (bis 1 Woche)",
        normal: "Standard (ab 1 Woche)",
        flexible: "Flexibel"
      },
      hasContent: "Ich habe bereits Inhalte/Materialien",
      additionalNotes: "Zusätzliche Anmerkungen"
    },
    step3: {
      title: "Überprüfung und Zahlung",
      subtitle: "Letzter Schritt vor der Zahlung",
      legalTitle: "Geschäftsbedingungen",
      termsClickToView: "Klicken Sie, um die AGB anzuzeigen und zu akzeptieren",
      termsAccepted: "Ich akzeptiere die Geschäftsbedingungen",
      payButton: "Zur Zahlung",
      processing: "Wird verarbeitet...",
      securePayment: "Sichere Zahlung über Stripe"
    },
    summary: {
      title: "Bestellübersicht",
      planLabel: "Tarif",
      planPromo: "Werbeangebot (12-Monats-Verpflichtung)",
      planOneTime: "Einmalige Zahlung",
      planPremium: "Premium mit Support",
      websiteSetup: "Website-Einrichtung",
      support: "Support",
      supportStartNote: "ab Monat 2",
      month: "Mon",
      totalToday: "Gesamt heute",
      subscriptionActivates: "Das Abonnement €50/Mon. wird nach 30 Tagen aktiviert.",
      minimumTerm: "Mindestlaufzeit — 12 Monate.",
      subscriptionNote: "Das Support-Abonnement beginnt nach dem ersten Monat.",
      commitmentNote: "Es gilt eine 12-monatige Support-Verpflichtung.",
      premiumSupportNote: "Premium-Support mit prioritärer Reaktion und dediziertem Entwickler."
    },
    trust: {
      stripe: "Sichere Zahlungen durch Stripe",
      ssl: "SSL-verschlüsselte Verbindung",
      noStorage: "Keine Kartendaten gespeichert",
      euCompany: "In der EU registriertes Unternehmen"
    },
    errors: {
      nameRequired: "Name ist erforderlich",
      emailRequired: "E-Mail ist erforderlich",
      emailInvalid: "Ungültiges E-Mail-Format",
      phoneRequired: "Telefonnummer ist erforderlich",
      phoneInvalid: "Ungültige Telefonnummer",
      descriptionRequired: "Projektbeschreibung ist erforderlich",
      termsRequired: "Sie müssen die Bedingungen akzeptieren, um fortzufahren"
    },
    terms: {
      title: "Geschäftsbedingungen",
      scrollNotice: "⬇ Bitte scrollen Sie bis zum Ende, um zu akzeptieren ⬇",
      closeButton: "Schließen",
      acceptButton: "Akzeptieren und Fortfahren",
      content: (
        <>
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">1. Unternehmen</h3>
            <p className="text-slate-300 leading-relaxed mb-4">
              Diese Website und die damit verbundenen Dienstleistungen werden betrieben von:
            </p>
            <div className="bg-slate-900/50 border border-slate-800 rounded-lg p-4 mb-4">
              <p className="text-white font-semibold mb-2">DATHENT SAX S.L.</p>
              <p className="text-slate-400 mb-1">CIF B22632632</p>
              <p className="text-slate-400 mb-1">Avenida Reyes Católicos 9, Bajo</p>
              <p className="text-slate-400 mb-3">03630 Sax (Alicante), Spanien</p>
            </div>
            <p className="text-slate-300 leading-relaxed">
              Dathent bietet strukturierte Website-Infrastruktur und langfristige technische Support-Lösungen für Unternehmen.
            </p>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">2. Service-Modelle</h3>
            <p className="text-slate-300 leading-relaxed mb-4">
              Dathent bietet zwei kommerzielle Modelle:
            </p>
            
            <div className="bg-slate-900/50 border border-slate-800 rounded-lg p-4 mb-4">
              <h4 className="text-base font-semibold text-white mb-2">A. Vollständiges Entwicklungsmodell</h4>
              <ul className="list-disc list-inside space-y-1 text-slate-300 text-sm">
                <li>Einmalige Zahlung: €1500</li>
                <li>Keine Abonnementverpflichtung.</li>
              </ul>
            </div>
            
            <div className="bg-slate-900/50 border border-slate-800 rounded-lg p-4">
              <h4 className="text-base font-semibold text-white mb-2">B. Infrastruktur-Verpflichtungsmodell</h4>
              <ul className="list-disc list-inside space-y-1 text-slate-300 text-sm">
                <li>Ersteinrichtung: €500</li>
                <li>Laufender Infrastruktur-Support: €50 pro Monat</li>
                <li>Mindestverpflichtung: 12 Monate</li>
              </ul>
              <div className="mt-3 p-3 bg-primary/10 border border-primary/20 rounded-lg">
                <p className="text-xs text-slate-300">
                  Der Standard-Support-Tarif beträgt €150 pro Monat. Der €50-Tarif ist ein vertraglicher Anreiz, der an die 12-Monats-Verpflichtung gebunden ist.
                </p>
              </div>
            </div>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">3. Kommerzielle Struktur</h3>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Die reduzierte Entwicklungsgebühr (€500) ist kein eigenständiges Produkt.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Sie ist Teil einer strukturierten Infrastrukturvereinbarung.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Der wirtschaftliche Wert der Entwicklung bleibt bei €1500.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Der reduzierte Einstiegspreis wird in Anbetracht der 12-Monats-Verpflichtung gewährt.</span>
              </li>
            </ul>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">4. Vorzeitige Kündigung</h3>
            <p className="text-slate-300 leading-relaxed mb-3 text-sm">
              Wenn der Kunde die Support-Vereinbarung vor Ablauf von 12 Monaten kündigt, wird der verbleibende wirtschaftliche Wert fällig.
            </p>
            <div className="bg-slate-900/50 border border-slate-800 rounded-lg p-4">
              <h4 className="text-base font-semibold text-white mb-2">Berechnung:</h4>
              <ul className="space-y-1 text-slate-300 text-sm">
                <li>Vollständiger Entwicklungswert: €1500</li>
                <li>Bei Einrichtung gezahlter Betrag: €500</li>
                <li className="font-semibold text-white pt-2 border-t border-slate-700 mt-2">Ausstehender Saldo: €1250</li>
              </ul>
            </div>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">5. Lieferrahmen</h3>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Typische Lieferzeit: ab 1 Woche.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Beschleunigte Lieferung kann je nach Projektumfang möglich sein.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Zeitpläne hängen von der Reaktionsfähigkeit des Kunden und der Projektkomplexität ab.</span>
              </li>
            </ul>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">6. Geistiges Eigentum</h3>
            <p className="text-slate-300 leading-relaxed mb-3 text-sm">
              Das vollständige Eigentum an der entwickelten Website wird nach Erfüllung der wirtschaftlichen Verpflichtungen übertragen unter:
            </p>
            <ul className="space-y-1 text-slate-300 text-sm">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>12-Monats-Infrastrukturverpflichtung</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="text-slate-500">ODER</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Vollständige Zahlung des Gesamtwertes von €1500</span>
              </li>
            </ul>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">7. Haftungsbeschränkung</h3>
            <p className="text-slate-300 leading-relaxed mb-3 text-sm">
              DATHENT SAX S.L. haftet nicht für:
            </p>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Unterbrechungen von Drittanbieterdiensten</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Ausfälle des Hosting-Anbieters</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Verzögerungen durch unvollständige Kundeninformationen</span>
              </li>
            </ul>
            <p className="text-slate-400 mt-3 text-sm">
              Die Haftung ist auf den Wert der erworbenen Dienstleistung beschränkt.
            </p>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">8. Anwendbares Recht</h3>
            <p className="text-slate-300 leading-relaxed text-sm">
              Diese Bedingungen unterliegen dem Recht Spaniens.
            </p>
          </section>
        </>
      )
    }
  }
};
